import React from 'react';
import {useNavigate} from 'react-router-dom';

import {FlatButton} from '@pb/kit-component-button';
import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import {Group, Item} from '@pb/kit-component-group';

type Props = {
    code: string,
    source: string,
    navigationPath: string,
};

export const PushNotificationExistingEvent = ({code, source, navigationPath}: Props) => {
    const navigate = useNavigate();

    const onClick = () => {
        navigate(navigationPath);
    };

    return (
        <Group justify="space-between" style={{maxWidth: '90%'}}>
            <Group direction="v" gap="s" style={{minWidth: '70%'}}>
                <Group gap="xs">
                    <Item shrink={0}>Event with code</Item>
                    <EllipsisTextHint bold={true}>{code}</EllipsisTextHint>
                </Group>
                <Group justify="start">
                    <Item>and source <strong>{source}</strong> already exists.</Item>
                </Group>
            </Group>
            <FlatButton onClick={onClick}>Go to Event</FlatButton>
        </Group>
    );
};
